import { render, staticRenderFns } from "./CrmNewEvent.vue?vue&type=template&id=42261982"
import script from "./CrmNewEvent.vue?vue&type=script&lang=js"
export * from "./CrmNewEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports